class VwHbsHastaraporsonucDTO {
    id: number = 0;
    organizasyonId?: number = null;
    kimlikId?: number = null;
    muracaatId?: number = null;
    hastaservisId?: number = null;
    raportiptanimId?: number = null;
    hastaislemId?: number = null;
    raportip?: number = null;
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    kabultarihsaat?: string = null;
    fkKabulkullanici?: number = null;
    numunedurum?: number = null;
    orderDetayId?: number = null;
    orderDetayAlanId?: number = null;
}
export default VwHbsHastaraporsonucDTO;